import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {InsightsService} from "../../services/insights/insights.service";
import * as Highcharts from 'highcharts/highcharts';
import HighchartsSolidGauge from 'highcharts/modules/solid-gauge';
import {AlertBannerService, AlertType} from "../../lib/alert-banner";
import {SolidgaugeChartService} from "../../services/solidgauge-chart/solidgauge-chart.service";
import HighchartsMore from "highcharts/highcharts-more";

HighchartsMore(Highcharts);
HighchartsSolidGauge(Highcharts);

@Component({
  selector: 'app-nps-category',
  templateUrl: './nps-category.component.pug',
  styleUrls: ['./nps-category.component.scss'],
  standalone: false
})
export class NpsCategoryComponent implements OnInit, OnChanges {

  @Input() start!: any;
  @Input() end!: any;
  @Input() questionnaire!: any;
  @Input() filterBy!: any;
  @Input() pause_load = false;

  promoter = 0
  passive = 0
  detractor = 0
  Highcharts: typeof Highcharts = Highcharts;
  promoterChartOptions = SolidgaugeChartService.getOptions(this.promoter, '#32735F', 'rgb(244,248,247)');
  passiveChartOptions = SolidgaugeChartService.getOptions(this.passive, '#DE8C02', 'rgb(253,249,242)');
  detractorChartOptions = SolidgaugeChartService.getOptions(this.detractor, '#AF0001', 'rgb(250,242,242)');

  constructor(private insightsService: InsightsService,
              private alertList: AlertBannerService,) {
  }

  ngOnInit(): void {
  }

  private loadAndSetData() {
    if (this.pause_load) {
      return;
    }
    this.insightsService.getNPSCategory(this.start, this.end, this.questionnaire, this.filterBy).subscribe(data => {
      this.promoter = this.passive = this.detractor = 0;
      for (let d of data) {
        if (d['category'] === 'promoter') {
          this.promoter = d['nps']
        } else if (d['category'] === 'passive') {
          this.passive = d['nps']
        } else if (d['category'] === 'detractor') {
          this.detractor = d['nps']
        }
      }

      this.setChartOptions();

    }, error => {
      console.log(error);
      this.promoter = this.passive = this.detractor = 0;
      this.setChartOptions();
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    });
  }

  private setChartOptions() {
    this.promoterChartOptions = SolidgaugeChartService.getOptions(this.promoter, '#32735F', 'rgb(244,248,247)');
    this.passiveChartOptions = SolidgaugeChartService.getOptions(this.passive, '#DE8C02', 'rgb(253,249,242)');
    this.detractorChartOptions = SolidgaugeChartService.getOptions(this.detractor, '#AF0001', 'rgb(250,242,242)');
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadAndSetData();
  }
}
